module.exports = __webpack_public_path__ + "static/media/bogota-1.591ae0d8.jpg";